import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 300 300">
    <path
      d="M122.6,125.9c-8.5,0-15.3,7.5-15.3,16.7c0,9.1,6.9,16.6,15.3,16.6c8.6,0,15.3-7.5,15.3-16.6
      C138.1,133.4,131.2,125.9,122.6,125.9z M177.4,125.9c-8.6,0-15.3,7.5-15.3,16.7c0,9.1,6.9,16.6,15.3,16.6c8.5,0,15.3-7.5,15.3-16.6
      C192.7,133.4,185.9,125.9,177.4,125.9z"
    />
    <path
      d="M250.5,0h-201c-17,0-30.8,13.8-30.8,30.9v202.8c0,17.1,13.8,30.9,30.8,30.9h170.1l-7.9-27.8l19.2,17.8
      l18.2,16.8l32.3,28.5V30.9C281.3,13.8,267.5,0,250.5,0z M192.6,195.9c0,0-5.4-6.5-9.9-12.2c19.7-5.6,27.2-17.8,27.2-17.8
      c-6.2,4-12,6.9-17.3,8.8c-7.5,3.2-14.7,5.3-21.8,6.4c-14.4,2.7-27.6,2-38.9-0.2c-8.5-1.7-15.9-4-22-6.4c-3.5-1.3-7.2-3-11-5.1
      c-0.5-0.3-0.9-0.5-1.4-0.8c-0.3-0.2-0.5-0.3-0.6-0.5c-2.7-1.5-4.2-2.5-4.2-2.5s7.2,12,26.3,17.7c-4.5,5.7-10,12.5-10,12.5
      c-33.2-1.1-45.8-22.8-45.8-22.8c0-48.3,21.6-87.5,21.6-87.5C106.5,69.5,127,69.9,127,69.9l1.5,1.8c-27,7.8-39.5,19.6-39.5,19.6
      s3.3-1.8,8.9-4.3c16-7,28.8-9,34.1-9.5c0.9-0.2,1.6-0.3,2.5-0.3c9.2-1.2,19.5-1.5,30.3-0.3c14.3,1.6,29.6,5.8,45.2,14.4
      c0,0-11.8-11.3-37.3-19l2.1-2.4c0,0,20.6-0.5,42.2,15.8c0,0,21.6,39.2,21.6,87.5C238.5,173.1,225.8,194.9,192.6,195.9z"
    />
  </svg>
);
